import { Pool, type SidebarComponent } from '@tunasong/ui-lib'
import React, { type FC } from 'react'

export const SidebarPool: FC<SidebarComponent> = ({ entity }) => <Pool entity={entity} />
